import type { IconName } from "../components/Icon.js";
import type { TranslationKey } from "../i18n/translations.js";

export interface NavigationItem {
  readonly icon: IconName;
  readonly key: TranslationKey;
  readonly path: string;
}

export const primaryNavigation: readonly NavigationItem[] = [
  { icon: "home", key: "nav.home", path: "/" },
  { icon: "alert", key: "nav.emergency", path: "/emergency" },
  { icon: "shield", key: "nav.disaster", path: "/disaster" },
  { icon: "book", key: "nav.learn", path: "/learn" },
  { icon: "search", key: "nav.search", path: "/search" },
  { icon: "family", key: "nav.family", path: "/family-plan" },
  { icon: "settings", key: "nav.settings", path: "/settings" },
] as const;

/** Kept out of the mobile action bar; it is a quiet desktop sidebar destination. */
export const secondaryNavigation: readonly NavigationItem[] = [
  { icon: "book", key: "nav.about", path: "/about" },
] as const;
